import { render, staticRenderFns } from "./InstapaymentIcon.vue?vue&type=template&id=30f60e24&"
import script from "./InstapaymentIcon.vue?vue&type=script&lang=js&"
export * from "./InstapaymentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports